export default __webpack_public_path__ + "static/media/user-pics-2.7b62b9cb.png";